function initializePromotion(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const choices = root.querySelectorAll('[data-choice]');
  const title = root.querySelector('#choice-title');
  const copy = root.querySelector('#choice-copy');
  const cta = root.querySelector('#choice-cta');
  const desktop = { title: title.textContent, copy: copy.textContent, cta: cta.textContent };
  choices.forEach(button => button.addEventListener('click', () => {
    choices.forEach(choice => {
      choice.classList.toggle('selected', choice === button);
      choice.setAttribute('aria-pressed', String(choice === button));
    });
    if (button.dataset.choice === 'desk') {
      title.textContent = desktop.title;
      copy.textContent = desktop.copy;
      cta.textContent = desktop.cta;
      cta.href = '#compare';
    } else {
      const key = button.dataset.choice === 'earbuds' ? 'lite' : 'mini';
      const card = root.querySelector('#' + key + '-card');
      title.textContent = card.querySelector('h3').textContent;
      copy.textContent = card.querySelector('.product-detail').textContent;
      cta.textContent = card.querySelector('h3').textContent + ' →';
      cta.href = '#' + key + '-card';
    }
  }));
  root.addEventListener('cart:error', event => {
    const feedback = event.target.querySelector('.card-feedback');
    if (!feedback) return;
    feedback.dataset.error = '';
    feedback.textContent = typeof event.detail?.error === 'string' ? event.detail.error : feedback.dataset.failure;
  });
  root.addEventListener('submit', event => {
    const feedback = event.target.querySelector('.card-feedback');
    if (feedback) {
      delete feedback.dataset.error;
      feedback.textContent = '';
    }
  }, true);
  const table = root.querySelector('.table-scroll');
  const controls = root.querySelector('[data-comparison-controls]');
  if (!table || !controls) return;
  const previous = controls.querySelector('[data-compare-direction="-1"]');
  const next = controls.querySelector('[data-compare-direction="1"]');
  const mobile = window.matchMedia('(max-width: 760px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let tableVisible = false;
  const updateControls = () => {
    table.style.setProperty('--comparison-model-width', `${Math.max(140, table.clientWidth - 110)}px`);
    const maximum = table.scrollWidth - table.clientWidth;
    controls.hidden = maximum <= 1;
    previous.disabled = table.scrollLeft <= 1;
    next.disabled = table.scrollLeft >= maximum - 1;
  };
  const updateFloatingButtons = () => {
    document.documentElement.classList.toggle('hd-comparison-active', mobile.matches && tableVisible);
  };
  controls.querySelectorAll('[data-compare-direction]').forEach(button => {
    button.addEventListener('click', () => {
      table.scrollBy({
        left: Number(button.dataset.compareDirection) * Math.max(140, table.clientWidth - 110),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });
  });
  table.addEventListener('scroll', updateControls, { passive: true });
  const resizeObserver = new ResizeObserver(updateControls);
  resizeObserver.observe(table);
  const visibilityObserver = new IntersectionObserver(entries => {
    tableVisible = entries[0].isIntersecting;
    updateFloatingButtons();
  });
  visibilityObserver.observe(table);
  mobile.addEventListener('change', updateFloatingButtons);
  updateControls();
  root.addEventListener('hd-promotion:unload', () => {
    resizeObserver.disconnect();
    visibilityObserver.disconnect();
    mobile.removeEventListener('change', updateFloatingButtons);
    document.documentElement.classList.remove('hd-comparison-active');
  }, { once: true });
}
document.querySelectorAll('[data-hd-promotion]').forEach(initializePromotion);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-hd-promotion]').forEach(initializePromotion);
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-hd-promotion]').forEach(root => {
    root.dispatchEvent(new Event('hd-promotion:unload'));
  });
});
